import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { startWith, map } from 'rxjs/operators';
import { FirestoreService } from 'src/services/firestore/firestore.service';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material';
import { AppDateAdapter } from 'src/shared/format-datepicker';

@Component({
  selector: 'app-informe-alumno',
  templateUrl: './informe-alumno.component.html',
  styleUrls: ['./informe-alumno.component.scss'],
  providers: [
    { provide: DateAdapter, useClass: AppDateAdapter },
    { provide: MAT_DATE_LOCALE, useValue: 'es-CL' }
  ]
})
export class InformeAlumnoComponent implements OnInit {

  /**
   * Variable que indica la pagina en la que te encuentras
   */
  p = 1;
  /**
   * Almacenaremos los alumnos
   */
  public alumnos = [];

  /**
   * Todas las evaluaciones
   */
  public evaluaciones = [];

  /**
   * informe del alumno Seleccionado
   */
  public registros = [];
  /**
   * Lista a mostrar
   */
  public alumnosAula = [];

  /**
   * Opciones a mostrar en nivel
   */
  opcionesNivel = [
    {
      nombre: 'Kinder'
    },
    {
      nombre: 'Pre Kinder'
    },

    {
      nombre: 'Medio Mayor'
    },
    {
      nombre: 'Medio Menor'
    },
    {
      nombre: 'Sala Cuna Mayor'
    },
    {
      nombre: 'Sala Cuna Menor'
    },
  ];

  public informeAlumnoForm = new FormGroup({
    // nivel: new FormControl([], Validators.required),
    alumno: new FormControl([], Validators.required),
    nivel: new FormControl([], Validators.required),
    fechaInicio: new FormControl('', Validators.required),
    fechaFin: new FormControl('', Validators.required),
    id: new FormControl('')
  });

  filteredNivel: Observable<any[]>;
  filteredOptions: Observable<any[]>;

  constructor(private firestoreService: FirestoreService, private dateAdapter: DateAdapter<any>) {
    this.informeAlumnoForm.setValue({
      id: '',
      alumno: [],
      nivel: [],
      fechaInicio: '',
      fechaFin: ''
    });
  }

  ngOnInit() {
    this.filtroNivel();
    this.getAlumnos();
    this.getInformes();
    this.dateAdapter.setLocale('es');
  }

  /**
   * Servicio que permite traer todos los alumnos
   */
  getAlumnos() {
    this.firestoreService.getAlums().subscribe(alumnosSnapshot => {
      this.alumnos = [];
      alumnosSnapshot.forEach((alumnosData: any) => {
        this.alumnos.push(
          alumnosData.payload.doc.data()
        );
      });
      this.alumnos.forEach(alumno => {
        alumno.nombreCompleto = alumno.nombre_alum.concat(' ')
          .concat(alumno.ape_pat_alum)
          .concat(' ')
          .concat(alumno.ape_mat_alum);
      });
      // this.filtroAlumnos();
    });
  }

  imprimir() {
    const printContent = document.getElementById('informe');
    const WindowPrt = window.open('', '', 'left=0,top=0,width=900,height=900,toolbar=0,scrollbars=0,status=0');
    WindowPrt.document.write(printContent.innerHTML);
    WindowPrt.document.close();
    WindowPrt.focus();
    WindowPrt.print();
    // WindowPrt.close();
  }

  /**
   * Segun lo que se ingrese en el input de nivel se actualizaran las opciones a mostrar
   */
  filtroNivel() {
    this.filteredNivel = this.informeAlumnoForm.controls.nivel.valueChanges.pipe(
      startWith(''),
      map(value => typeof value === 'string' ? value : value.nombre),
      map(name => name ? this._filterNivel(name) : this.opcionesNivel.slice())
    );
  }

  private _filterNivel(name: string): any[] {
    const filterValue = name.toLowerCase();
    return this.opcionesNivel.filter(option => option.nombre.toLowerCase().indexOf(filterValue) === 0);
  }


  onSelectionChange(event) {
    this.alumnosAula = [];
    this.alumnos.forEach(alumno => {
      if (alumno.nivel_educ.toLowerCase().trim() === event.option.value.toLowerCase().trim()) {
        this.alumnosAula.push(alumno);
      }
    });
    this.alumnosAula.sort((a, b) => {
      return a.nombreCompleto.localeCompare(b.nombreCompleto);
    });
    this.filtroAlumnos();
  }

  change(event) {
    this.alumnosAula = [];
    this.alumnos.forEach(alumno => {
      if (alumno.nivel_educ.toLowerCase().trim() === event.target.value.toLowerCase().trim()) {
        this.alumnosAula.push(alumno);
      }
    });
    this.alumnosAula.sort((a, b) => {
      return a.nombreCompleto.localeCompare(b.nombreCompleto);
    });
    this.filtroAlumnos();
  }

  limpiar() {
    this.informeAlumnoForm.reset();
    this.registros = [];
    this.filtroNivel();
  }
  /**
   * Segun lo que se ingrese en el input de alumno se actualizaran las opciones a mostrar
   */
  filtroAlumnos() {
    console.log(this.alumnosAula);
    this.filteredOptions = this.informeAlumnoForm.controls.alumno.valueChanges
      .pipe(
        startWith(''),
        // map(value => typeof value === 'string' ? value : value.nombreCompleto),
        map(name => name ? this._filter(name) : this.alumnosAula.slice())
      );
  }

  private _filter(name: string): any[] {
    const filterValue = name.toLowerCase();
    return this.alumnosAula.filter(option => option.nombreCompleto.toLowerCase().indexOf(filterValue) === 0);
  }

  getInformes() {
    this.firestoreService.getAllData('Evaluaciones').subscribe(evaluacionesSnapshot => {
      this.evaluaciones = [];
      evaluacionesSnapshot.forEach((evaluacionesData: any) => {
        this.evaluaciones.push({
          id: evaluacionesData.payload.doc.id,
          data: evaluacionesData.payload.doc.data()
        });
      });
    });
  }

  informeAlumno() {
    const fecha: Date = new Date(this.informeAlumnoForm.controls.fechaFin.value);
    fecha.setDate(fecha.getDate() + 1);
    fecha.setHours(0);
    fecha.setMinutes(0);
    this.registros = this.evaluaciones.filter(evaluacion => evaluacion.data.alumno === this.informeAlumnoForm.controls.alumno.value &&
      evaluacion.data.fecha >= this.informeAlumnoForm.controls.fechaInicio.value.getTime() &&
      evaluacion.data.fecha < fecha.getTime());
    this.registros.sort((a, b) => {
      if (a.data.fecha <= b.data.fecha) {
        return 1;
      } else {
        return -1;
      }
    });
  }
}
